import id from "date-fns/esm/locale/id/index"

export const cargoType = [
    { label: 'Volumetric', value: 0 },
    { label: 'Non Volumetric', value: 1}
]

export const productUnit = [
    { label: 'CM', value: 'CM' },
    { label: 'IN', value: 'IN' },
    { label: 'FT', value: 'IN' },
    { label: 'MM', value: 'MM' },
    { label: 'MT', value: 'MT' }
]

export const physicalState = [
    { label: 'Solid', value : 'Solid' },
    { label: 'Liquid', value : 'Liquid' },
    { label: 'Purity', value: 'Purity'}
]

export const dplPhysicalState = [
    { label: 'Solid', value : 'Solid' },
    { label: 'Liquid', value : 'Liquid' },
    { label: 'Purity', value: 'Purity'},
    { label: 'Gas', value: 'Gas'}
]

export const stackingPermitted = [
    { label: 'Permitted', value: 'Permitted' },
    { label: 'Not permitted', value: 'Not permitted' },
    { label: 'NA', value: 'NA' }
]

export const companyName = [
    { label: 'Pfizer Ltd', value: 1 },
    { label: 'PPIPL', value: 2},
    { label: 'Bacardi', value: 3},
    { label: 'Beam Suntory', value: 4},
    { label: 'Roquette', value: 5},
    { label: 'Cargill', value: 6},
    { label: 'Emami', value: 7},
    { label: ' Sap Deepak Phenolics', value: 8},
]

export const chainType = [
    { label: 'Cold Chain', value: 1 },
    { label: 'Non Cold Chain', value: 2 }
]

export const uomType = [
    { label: 'Hours', value: 'hours' },
    { label: 'Days', value: 'days' }
]

export const detentionType = [
    { label: 'At Origin', value: 'at_origin' },
    { label: 'At Destination', value: 'at_destination' },
    { label: 'Both', value: 'both' }
]

export const damagesUOM = [
    { label: 'Amount', value: 'amount'},
    { label: 'Percentage', value: 'percentage'}
]

export const modeType = [
    { label: 'Road', value: 1 },
    { label: 'Train', value: 2 },
    { label: 'Air', value: 3 }
]

export const loadType = [
    { label: 'FTL', value: 1 },
    { label: 'LCL', value: 2 },
    { label: 'Courier', value: 3 }
]

export const modeLoadType = [
    { label: 'FTL Road', value: 1 },
    { label: 'FTL Train', value: 2 },
    { label: 'LCL Road', value: 3 },
    { label: 'LCL Train', value: 4 },
    { label: 'Courier Road', value: 5 },
    { label: 'Courier Air', value: 6 }
]

export const challengePriceWithCounter = [
    { label: 0, value: 0 },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 'Any', value: -1 },
]

export const handlingInstruction = [
    { label: 'Hazardous', value: 1 },
    { label: 'Non-Hazardous', value: 2 }
]

export const typesOfUse =[
    {label:'Dedicated', value:1 },
    {label:'Market', value:2 },

]

export const typeOfOperations =[
    {label:'Short-Haul', value:1 },
    {label:'Long-Haul', value:2 },
 
]


export const unloadingMhe =[
    {label:'Handtrolley', value:1 },
    {label:'Forklift', value:2 },

]
export const PackagingType =[
    {label:'Bin', value:1 },
    {label:'Trolley', value:2 },

]
export const LoadType =[
    {label:'Club', value:1 },
    {label:'Single', value:2 },

] 

export const BoundType =[
    {label:'Inbound', value:1 },
    {label:'Outbound', value:2 },

] 

export const companyIds = ["f5862184a9b648b8ae3c8cfc4dbe242d"];
export const ROQUETTE = ['a5dfe89d1723470aa6058fb8f0f10694'];

export function downloadUrl(urlLink) {
	localStorage.setItem('teg-component', true);
	const link = document.createElement('a');
	link.href = urlLink;
	document.body.appendChild(link);
	link.click();
}

export const lrManageType = [
    { label: 'LR', value: 1 },
    { label: 'AWB', value: 2 },
]

export const WEIGHMENT_PROCESS_TYPES = [
    { value: 1, label: "Ricelake" },
    { value: 2, label: "ABB" },
    { value: 3, label: "ABB(PGI) and Ricelake" },
    { value: 4, label: "ABB and Ricelake(PGI)" },
];

export const SERVICE_TYPES = [
    { 
        load_type: 1, 
        load_name: "FTL", 
        mode_type: 1, 
        mode_name: 'Road', 
        display_name: 'FTL Road',
        id: 1, 
    },
    { 
        load_type: 8, 
        load_name: "BCN", 
        mode_type: 2, 
        mode_name: 'Rail', 
        display_name: 'BCN Rail',
        id: 2 
    },
    { 
        load_type: 4, 
        load_name: "Container", 
        mode_type: 2, 
        mode_name: 'Rail', 
        display_name: 'Rail Container',
        id: 3 
    }
];
